import { IconPropsType } from '..';

export const BorderedLockIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.991 0.800003H5.02221L0.799988 5.01557V10.9844L5.02221 15.2H10.991L15.2 10.9844V5.01557L10.991 0.800003ZM13.8971 10.4429L10.4496 13.8971H5.56371L2.10284 10.4429V5.55708L5.56371 2.10286H10.4496L13.8971 5.55708V10.4429Z"
      fill="#6A6F85"
    />
    <path
      d="M5.86665 6.88V6.16C5.86665 5.58714 6.09142 5.03773 6.49149 4.63265C6.89157 4.22757 7.43419 4 7.99999 4C8.56578 4 9.1084 4.22757 9.50848 4.63265C9.90856 5.03773 10.1333 5.58714 10.1333 6.16V6.88H10.4889C10.6775 6.88 10.8583 6.95586 10.9917 7.09089C11.1251 7.22591 11.2 7.40905 11.2 7.6V11.28C11.2 11.471 11.1251 11.6541 10.9917 11.7891C10.8583 11.9241 10.6775 12 10.4889 12H5.5111C5.3225 12 5.14163 11.9241 5.00827 11.7891C4.87491 11.6541 4.79999 11.471 4.79999 11.28V7.6C4.79999 7.204 5.11999 6.88 5.5111 6.88H5.86665ZM7.64443 9.3028V10.12H8.35554V9.3028C8.49111 9.22355 8.59706 9.10123 8.65697 8.9548C8.71687 8.80836 8.72738 8.64601 8.68687 8.49291C8.64635 8.33982 8.55708 8.20454 8.43288 8.10805C8.30869 8.01156 8.15653 7.95926 7.99999 7.95926C7.84345 7.95926 7.69128 8.01156 7.56709 8.10805C7.4429 8.20454 7.35362 8.33982 7.31311 8.49291C7.27259 8.64601 7.2831 8.80836 7.34301 8.9548C7.40291 9.10123 7.50886 9.22355 7.64443 9.3028ZM6.93332 6.16V6.88H9.06665V6.16C9.06665 5.87357 8.95427 5.59887 8.75423 5.39633C8.5542 5.19379 8.28288 5.08 7.99999 5.08C7.71709 5.08 7.44578 5.19379 7.24574 5.39633C7.0457 5.59887 6.93332 5.87357 6.93332 6.16Z"
      fill="#6A6F85"
    />
  </svg>
);
